export const EXISTING_CUSTOMER_ALLOWED_CONNECTIONS_ERROR_ID =
  'existing-customer-allowed-connections-error';
